import { API_DOMAIN, COMING_CHECKOUT_SSE_ENABLED } from '../config'
import { getCookie, stringContainsAnyOf } from '../utils/Utils'
import { COMING_CHECKOUT_SSE_ROLES } from '../Constants'

const canUseComingCheckoutSSE = (user) => {
  if (!COMING_CHECKOUT_SSE_ENABLED || !user || !user.center_id) {
    return false
  }

  return stringContainsAnyOf(user.role, COMING_CHECKOUT_SSE_ROLES)
}
  
const buildStreamUrl = (centerId) =>
  `${API_DOMAIN}miadvenio/centers/${centerId}/coming-checkout/stream`

const parseSSEChunk = (buffer, callbacks, state) => {
  const parts = buffer.split('\n')
  const remainder = parts.pop() || ''
  let currentEvent = state.currentEvent || 'message'

  parts.forEach((line) => {
    if (line.startsWith('event: ')) {
      currentEvent = line.slice(7).trim()
      return
    }

    if (!line.startsWith('data: ')) {
      return
    }

    try {
      const data = JSON.parse(line.slice(6))

      if (currentEvent === 'coming_checkout' && callbacks.onCheckout) {
        callbacks.onCheckout(data)
      }

      if (currentEvent === 'ping' && callbacks.onPing) {
        callbacks.onPing(data)
      }
    } catch (error) {
      if (callbacks.onError) {
        callbacks.onError(error)
      }
    }
  })

  state.currentEvent = currentEvent

  return remainder
}

export const connectComingCheckoutSSE = (centerId, callbacks = {}) => {
  const token = getCookie('advenio_api_key')

  if (!token || !centerId) {
    return { disconnect: () => {} }
  }

  const controller = new AbortController()
  const state = { currentEvent: 'message', reconnectTimeout: null }

  const readStream = (response) => {
    const reader = response.body.getReader()
    const decoder = new TextDecoder()
    let buffer = ''

    const read = () => {
      reader.read().then(({ done, value }) => {
        if (done || controller.signal.aborted) {
          return
        }

        buffer += decoder.decode(value, { stream: true })
        buffer = parseSSEChunk(buffer, callbacks, state)
        read()
      }).catch((error) => {
        if (!controller.signal.aborted && callbacks.onError) {
          callbacks.onError(error)
        }
      })
    }

    read()
  }

  const connect = () => {
    if (controller.signal.aborted) {
      return
    }

    fetch(buildStreamUrl(centerId), {
      method: 'GET',
      headers: {
        Accept: 'text/event-stream',
        Authorization: `Bearer ${token}`,
      },
      signal: controller.signal,
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error(`SSE error ${response.status}`)
        }

        readStream(response)
      })
      .catch((error) => {
        if (controller.signal.aborted) {
          return
        }

        if (callbacks.onError) {
          callbacks.onError(error)
        }

        state.reconnectTimeout = setTimeout(connect, 5000)
      })
  }

  connect()

  return {
    disconnect: () => {
      controller.abort()

      if (state.reconnectTimeout) {
        clearTimeout(state.reconnectTimeout)
      }
    },
  }
}

export { canUseComingCheckoutSSE, COMING_CHECKOUT_SSE_ENABLED }



// WEBPACK FOOTER //
// ./src/services/ComingCheckoutSSE.js